import { render, staticRenderFns } from "./MetricsItem.vue?vue&type=template&id=f7bb8af2&scoped=true&lang=pug&"
import script from "./MetricsItem.vue?vue&type=script&lang=js&"
export * from "./MetricsItem.vue?vue&type=script&lang=js&"
import style0 from "./MetricsItem.vue?vue&type=style&index=0&id=f7bb8af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bb8af2",
  null
  
)

export default component.exports